import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Guitar, CheckCircle2 } from 'lucide-react';
const NAMES = ['Martín', 'Lucía', 'Santiago', 'Camila', 'Mateo', 'Valentina', 'Nicolás', 'Florencia', 'Tomás', 'Carolina'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Misiones', 'Neuquén', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    province: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomProvince = PROVINCES[Math.floor(Math.random() * PROVINCES.length)];
      setCurrentBuyer({
        name: randomName,
        province: randomProvince
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show randomly every 15-25 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-265">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 50
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 50
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-white border-l-4 border-amber-500 rounded-r-lg shadow-2xl p-4 flex items-start gap-4" data-id="element-266">
          <div className="bg-amber-100 p-2 rounded-full flex-shrink-0" data-id="element-267">
            <Guitar className="w-6 h-6 text-amber-600" data-id="element-268" />
          </div>
          <div data-id="element-269">
            <div className="flex items-center gap-1 mb-1" data-id="element-270">
              <p className="text-sm font-bold text-stone-900" data-id="element-271">
                {currentBuyer.name} de {currentBuyer.province}
              </p>
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-272" />
            </div>
            <p className="text-xs text-stone-600" data-id="element-273">
              acaba de comprar el Mega Kit Docente
            </p>
            <p className="text-[10px] text-stone-400 mt-1" data-id="element-274">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}